

export default {
    "global.common.cancel": "取消",
    "global.modal.close": "关闭",
    "global.common.update_OK": "确定",
    "global.common.init": "正在初始化数据,请稍等...",
    // "global.common.initError": "<div class=color-error>数据初始化失败,正在退出登录,请重新登录！</div>",
    "global.common.initError": "<div class=color-error>系统正在加载中，请稍后...</div>",
    "global.common.newInitError": "<div class=color-error>载入中请稍候...</div>",
    "global.common.maxlist": "最大限制数量 {count} 条",
    "global.common.noDataText": "暂时没有相关数据",
    "global.common.nodata": "没有找到相关数据",
    "global.common.operation": "操作",
    "global.common.operates": "更多操作",
    "global.common.organization": "组织",
    "global.common.pageError": "对不起，加载页面时遇到了错误！",
    "global.common.panel": "主面板",
    "global.common.reset": "重置",
    "global.common.search": "搜索",
    "global.common.searchs": "更多搜索",
    "global.common.signout": "退出",
    "global.datepicker.clear": "清除",
    "global.datepicker.confirm": "确认",
    "global.datepicker.month": "{month}月",
    "global.datepicker.selectDate": "选择日期",
    "global.datepicker.selectTime": "选择时间",
    "global.datepicker.time": "时间",
    "global.common.year": "年",
    "global.common.fill_required": "该信息不能为空,请填写",
    "global.form.warning": "系统可能不会保存您所做的更改",
    "global.table.noDataText": "没有数据",
    "global.loading.canceljump": "取消自动跳转",
    "global.loading.delayjump": "秒后自动跳转",
    "global.loading.jump": "跳转",
    "global.common.operate_type": "操作类型",
    "global.common.operate_time": "操作时间",
    "global.common.operate_history": "操作历史",
    "global.common.operator": "操作人",
    "global.common.operate_note": "操作原因",
    "global.common.update_OK": "确定",
    "global.nav.module": "模块",
    "global.nav.shorttip": "通过名称/关键字查找产品（例如：用户管理-列表、FBA中转等）",
    "global.page.goto": "跳至",
    "global.page.next": "下一页",
    "global.page.nextStep": "后{step}页",
    "global.page.onePageCount": "{index}/每页",
    "global.page.page": "页",
    "global.page.pre": "上一页",
    "global.page.preStep": "前{step}页",
    "global.page.total": "共{total}条",
    "global.common.finished": "已完成",
    "global.upload.fail": "失败",
    "global.upload.residue": "剩余",
    "global.common.select_attachment": "请选择文件",
    "global.upload.import": "确认导入",
    "global.common.download_template": "下载模板",
    "global.common.reset_password": "你的密码已过期，请修改密码",
}